import RetoolContainer from '../components/RetoolContainer';
import { TransformedAuditBoard } from '../Types/Audit';

interface AuditProps {
    selectedAudit?: TransformedAuditBoard;
}

const WorksheetProperties: React.FC<AuditProps> = ({ selectedAudit }) => {
    return (
        <div className="h-full w-full flex p-2">
            <RetoolContainer
                appName=""
                appUUID="c757d2f0-f946-11ef-aa23-1b0f3dc58570"
                data={{ worksheet_id: selectedAudit?.id }}
            ></RetoolContainer>
        </div>
    );
};

export default WorksheetProperties;
